import React from 'react';
import { useTranslation } from 'react-i18next';

import { Layout } from '../components/layout';
import { useConfiguration } from '../hooks/useConfiguration';
import { MedicalDevice } from '../elements/about/medicalDevice';
import { SupportedDevices } from '../elements/about/supportedDevices';
import { DeclarationOfConformity } from '../elements/about/declarationOfConformity';
import { IntendedUse } from '../elements/about/intendedUse';
import { Version } from '../elements/about/version';

export const About = () => {
  const configuration = useConfiguration();

  const { t } = useTranslation();

  if (configuration === undefined) {
    return null;
  }

  const { copyright, region } = configuration;


  return (
    <Layout copyright={copyright}>
      <section className='profile'>
        <div className='content'>
          <div className='text'>
            <IntendedUse region={region} />
            <MedicalDevice region={region} />
            <hr />
            <h2>{t('about.systemRequirements.title')}</h2>
            <ul>
              <li>{t('about.systemRequirements.text.paragraph_1')}</li>
              <li>{t('about.systemRequirements.text.paragraph_2')}</li>
              <li>{t('about.systemRequirements.text.paragraph_3')}</li>
            </ul>

            <hr />

            <SupportedDevices region={region} />
            <DeclarationOfConformity region={region} />
            <Version />
          </div>
        </div>
        <div className='clear-footer'></div>
      </section>
    </Layout>
  );
};
